import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, Calendar } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

interface KTContactDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSendContact: (email: string) => void;
  onCreateFollowUp: (email: string) => void;
  currentEmail?: string;
}

export function KTContactDialog({
  open,
  onOpenChange,
  onSendContact,
  onCreateFollowUp,
  currentEmail = "",
}: KTContactDialogProps) {
  const [email, setEmail] = useState(currentEmail);

  const handleSendContact = () => {
    if (!email || !email.includes("@")) {
      toast.error("Bitte geben Sie eine gültige E-Mail-Adresse ein");
      return;
    }
    onSendContact(email);
    onOpenChange(false);
  };

  const handleCreateFollowUp = () => {
    onCreateFollowUp(email);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>KT - Kontakt / Termin</DialogTitle>
          <DialogDescription>
            E-Mail-Adresse eingeben und Aktion wählen
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="email">E-Mail-Adresse</Label>
            <Input
              id="email"
              type="email"
              placeholder="kunde@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
          </div>
          <div className="flex flex-col gap-2">
            <Button
              onClick={handleSendContact}
              className="w-full"
              variant="default"
            >
              <Mail className="mr-2 h-4 w-4" />
              Kontaktdaten senden
            </Button>
            <Button
              onClick={handleCreateFollowUp}
              className="w-full"
              variant="outline"
            >
              <Calendar className="mr-2 h-4 w-4" />
              Follow-up erstellen
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
